if($('#filters').length){
    function mhfiltercount(){
        $('.filters-unveil-button-wrapper').append('<i>0</i>')
        var find_count = $('.filters .filter-label.active').length
        $('.filters-unveil-button-wrapper>i').html(find_count)
    }
   $(document).ready(function() { 
        mhfiltercount(); 
    });  
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        mhfiltercount();
    });  

}